import { createRoutine } from 'redux-saga-routines';

const FETCH_PROFILE_ACTION_PREFIX = 'FETCH_PROFILE_ACTION';
export const fetchProfileAction = createRoutine(FETCH_PROFILE_ACTION_PREFIX);

const UPDATE_PROFILE_ACTION_PREFIX = 'UPDATE_PROFILE_ACTION';
export const updateProfileAction = createRoutine(UPDATE_PROFILE_ACTION_PREFIX);
